import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

import { RdsNullParameterIconPipeModule, RdsNullParameterLabelPipeModule, RdsNullParameterOptionIconPipeModule } from '../core/pipes/index';
import { RdsNullFilterComponent } from './null-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    RdsNullParameterIconPipeModule,
    RdsNullParameterLabelPipeModule,
    RdsNullParameterOptionIconPipeModule,
    ReactiveFormsModule,
  ],
  exports: [RdsNullFilterComponent],
  declarations: [RdsNullFilterComponent],
})
export class RdsNullFilterModule {}

export * from './null-filter.component';
